export interface FieldType {
  id: string;
  name: string;
  type: DataTypeEnum;
  required: boolean;
  validationRules: Record<string, any>;
  defaultValue?: string;
  active: boolean;
  weight?: number;
  parent?: FieldType | null;
  referenceEntity?: ReferenceEntityName | null;
  allowMultiple: boolean;
  createdAt: string;
  updatedAt: string;
  fieldTypes?: FieldType[];
}

export enum DataTypeEnum {
  Group = "group",
  String = "string",
  Text = "text",
  Number = "integer",
  NumberWithDecimals = "double",
  Date = "date",
  List = "list",
  Reference = "reference",
  Image = "image",
  Video = "video",
  Boolean = "boolean",
}

export enum ReferenceEntityName {
  Institution = "Institution",
  Tag = "Tag",
  JourneyType = "JourneyType",
  CampusActivity = "CampusActivity",
  Field = "Field",
  Country = "Country",
}

export const DataTypeLabels: Record<DataTypeEnum, string> = {
  [DataTypeEnum.Boolean]: "Checkbox",
  [DataTypeEnum.Date]: "Date",
  [DataTypeEnum.Group]: "Group",
  [DataTypeEnum.Image]: "Image",
  [DataTypeEnum.List]: "List",
  [DataTypeEnum.Number]: "Number",
  [DataTypeEnum.NumberWithDecimals]: "Number with Decimals",
  [DataTypeEnum.Reference]: "Reference",
  [DataTypeEnum.String]: "String",
  [DataTypeEnum.Text]: "Text",
  [DataTypeEnum.Video]: "Video",
};

export const ReferenceEntityLabels: Record<ReferenceEntityName, string> = {
  [ReferenceEntityName.Institution]: "Institution",
  [ReferenceEntityName.Tag]: "Tag",
  [ReferenceEntityName.JourneyType]: "Journey Type",
  [ReferenceEntityName.CampusActivity]: "Campus Activity",
  [ReferenceEntityName.Field]: "Field",
  [ReferenceEntityName.Country]: "Country",
};

export interface CreateFieldTypePayload {
  name: string;
  type: DataTypeEnum;
  required?: boolean;
  parent_id?: string | null;
  group_id?: string | null;
  list_items?: string[];
  allow_unlisted?: boolean;
  reference_entity?: ReferenceEntityName | null;
  allow_multiple?: boolean;
  default_value?: string | null;
  active?: boolean;
  weight?: number | null;
  min_number?: number;
  max_number?: number;
  decimal_characters?: number;
  max_size?: number;
  min_width?: number;
  max_width?: number;
  min_height?: number;
  max_height?: number;
  is_avatar_config?: boolean;
}

export interface UpdateFieldTypePayload extends CreateFieldTypePayload {}

export interface FieldTypeResponseData {
  data: FieldType;
  code: number;
}

export interface FieldTypesResponseData {
  data: FieldType[];
  meta: {
    code: number;
  };
  pagination: {
    total_count: number;
    page?: number;
    limit?: number;
    offset?: number;
  };
}

export interface FieldTypeSearchGroupsResponseData {
  data: FieldType[];
}

export interface AllFieldTypesResponseData {
  data: FieldType[];
  meta: {
    code: number;
  };
}
